import { Routes } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { AuthGuard } from './pages/auth/auth.guard';
const ɵ0 = () => import("./pages/auth/auth.module.ngfactory").then(r => r.AuthModuleNgFactory), ɵ1 = () => import("./pages/treatments-print-page/treatments-print-page.module.ngfactory").then(r => r.TreatmentsPrintPageModuleNgFactory), ɵ2 = () => import("./pages/users/users.module.ngfactory").then(m => m.UsersModuleNgFactory), ɵ3 = () => import("./pages/treatments/treatments.module.ngfactory").then(m => m.TreatmentsModuleNgFactory), ɵ4 = () => import("./pages/quotes/quotes.module.ngfactory").then(m => m.QuotesModuleNgFactory), ɵ5 = () => import("./pages/quotes/quotes.module.ngfactory").then(m => m.QuotesModuleNgFactory), ɵ6 = () => import("./pages/new-patient/new-patient.module.ngfactory").then(m => m.NewPatientModuleNgFactory), ɵ7 = () => import("./pages/new-quote/new-quote.module.ngfactory").then(m => m.NewQuoteModuleNgFactory), ɵ8 = () => import("./pages/new-doctor/new-doctor.module.ngfactory").then(m => m.NewDoctorModuleNgFactory), ɵ9 = () => import("./pages/planning-page/planning-page.module.ngfactory").then(m => m.PlanningPageModuleNgFactory), ɵ10 = () => import("./pages/user-group/user-group.module.ngfactory").then(m => m.UserGroupModuleNgFactory), ɵ11 = () => import("./pages/linked-cloud/linked-cloud.module.ngfactory").then(m => m.LinkedCloudModuleNgFactory), ɵ12 = () => import("./pages/holidays/holidays.module.ngfactory").then(m => m.HolidaysModuleNgFactory), ɵ13 = () => import("./pages/calendar-page/calendar-page.module.ngfactory").then(m => m.CalendarPageModuleNgFactory), ɵ14 = () => import("./pages/my-profile/my-profile.module.ngfactory").then(m => m.MyProfileModuleNgFactory), ɵ15 = () => import("./pages/live-chat/live-chat.module.ngfactory").then(m => m.LiveChatModuleNgFactory), ɵ16 = () => import("./pages/treatments-next-phase/treatments-next-phase.module.ngfactory").then(m => m.TreatmentsNextPhaseModuleNgFactory), ɵ17 = () => import("./pages/treatments-report/treatments-report.module.ngfactory").then(m => m.TreatmentsReportModuleNgFactory), ɵ18 = () => import("./pages/treatment-planning/treatment-planning.module.ngfactory").then(m => m.TreatmentPlanningModuleNgFactory), ɵ19 = () => import("./pages/users/users.module.ngfactory").then(m => m.UsersModuleNgFactory), ɵ20 = () => import("./pages/create-edit-user-page/create-edit-user-page.module.ngfactory").then(m => m.CreateEditUserPageModuleNgFactory), ɵ21 = () => import("./pages/create-edit-user-page/create-edit-user-page.module.ngfactory").then(m => m.CreateEditUserPageModuleNgFactory), ɵ22 = () => import("./pages/doctors-list/doctors-list.module.ngfactory").then(m => m.DoctorsListModuleNgFactory), ɵ23 = () => import("./pages/dashboard/dashboard-statistics.module.ngfactory").then(m => m.DashboardStatisticsModuleNgFactory), ɵ24 = () => import("./pages/dashboard-treatments-list/dashboard-treatments-list.module.ngfactory")
    .then(m => m.DashboardTreatmentsListModuleNgFactory), ɵ25 = () => import("./pages/contents/contents.module.ngfactory").then(m => m.ContentsModuleNgFactory);
const routes = [
    {
        path: '',
        children: [
            {
                path: '',
                loadChildren: ɵ0
            },
        ]
    },
    {
        path: '',
        children: [
            {
                path: '',
                loadChildren: ɵ1
            }
        ]
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'users',
                canActivate: [AuthGuard],
                pathMatch: 'full',
                loadChildren: ɵ2
            },
            {
                path: 'treatments',
                loadChildren: ɵ3
            },
            {
                path: 'quotes',
                loadChildren: ɵ4
            },
            {
                path: 'tell-me-yes',
                loadChildren: ɵ5
            },
            {
                path: '',
                loadChildren: ɵ6
            },
            {
                path: '',
                loadChildren: ɵ7
            },
            {
                path: '',
                loadChildren: ɵ8
            },
            {
                path: 'planning',
                loadChildren: ɵ9
            },
            {
                path: 'users-group',
                loadChildren: ɵ10
            },
            {
                path: 'linked-cloud',
                loadChildren: ɵ11
            },
            {
                path: 'holidays',
                loadChildren: ɵ12
            },
            {
                path: 'calendar',
                loadChildren: ɵ13
            },
            {
                path: 'myprofile',
                loadChildren: ɵ14
            },
            {
                path: 'livechat',
                loadChildren: ɵ15
            },
            {
                canActivate: [AuthGuard],
                // canDeactivate: [CanDeactivateGuard],
                path: 'next-phase/:id',
                loadChildren: ɵ16
            },
            {
                canActivate: [AuthGuard],
                path: 'treatments-report',
                loadChildren: ɵ17
            },
            {
                canActivate: [AuthGuard],
                path: 'treatment-planning/:id',
                loadChildren: ɵ18
            }
        ]
    },
    {
        path: 'users',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                canActivate: [AuthGuard],
                pathMatch: 'full',
                loadChildren: ɵ19
            },
            {
                path: 'edit/:id',
                canActivate: [AuthGuard],
                pathMatch: 'full',
                loadChildren: ɵ20
            },
            {
                path: 'new',
                canActivate: [AuthGuard],
                pathMatch: 'full',
                loadChildren: ɵ21
            },
            {
                path: 'list',
                canActivate: [AuthGuard],
                pathMatch: 'full',
                loadChildren: ɵ22
            },
        ]
    },
    {
        path: 'dashboard',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: ɵ23
            },
            {
                path: 'list/:filter',
                loadChildren: ɵ24
            }
            // {
            //   path: 'apps/chat',
            //   loadChildren: () => import('./pages/chat/chat.module').then(m => m.ChatModule)
            // },
            // {
            //   path: 'components',
            //   loadChildren: () => import('./pages/components/components.module').then(m => m.ComponentsModule)
            // },
            // {
            //   path: 'forms',
            //   loadChildren: () => import('./pages/forms/forms.module').then(m => m.FormModule)
            // },
            // {
            //   path: 'apps/inbox',
            //   loadChildren: () => import('./pages/inbox/inbox.module').then(m => m.InboxModule)
            // },
            // {
            //   path: 'pages/profile',
            //   loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule)
            // },
            // {
            //   path: 'tables/simple-table',
            //   loadChildren: () => import('./pages/tables/simple-table/simple-table.module').then(m => m.SimpleTableModule)
            // },
            // {
            //   path: 'tables/table-pagination',
            //   loadChildren: () => import('./pages/tables/table-pagination/table-pagination.module').then(m => m.TablePaginationModule)
            // },
            // {
            //   path: 'tables/table-sorting',
            //   loadChildren: () => import('./pages/tables/table-sorting/table-sorting.module').then(m => m.TableSortingModule)
            // },
            // {
            //   path: 'tables/table-filtering',
            //   loadChildren: () => import('./pages/tables/table-filtering/table-filtering.module').then(m => m.TableFilteringModule)
            // },
            // {
            //   path: 'tables/datatable',
            //   loadChildren: () => import('./pages/tables/datatable/datatable.module').then(m => m.DatatableModule)
            // },
            // {
            //   path: 'tables/all-in-one-table',
            //   loadChildren: () => import('./pages/tables/all-in-one-table/all-in-one-table.module').then(m => m.AllInOneTableModule)
            // },
            // {
            //   path: 'maps/google-maps',
            //   loadChildren: () => import('./pages/google-maps/google-maps.module').then(m => m.GoogleMapsModule)
            // },
            // {
            //   path: 'pages/projects',
            //   loadChildren: () => import('./pages/projects/projects.module').then(m => m.ProjectsModule)
            // },
            // {
            //   path: 'pages/project-details',
            //   loadChildren: () => import('./pages/project-details/project-details.module').then(m => m.ProjectDetailsModule)
            // },
            // {
            //   path: 'material-icons',
            //   loadChildren: () => import('./pages/icon/icon.module').then(m => m.IconModule)
            // },
            // {
            //   path: 'editor',
            //   loadChildren: () => import('./pages/editor/editor.module').then(m => m.EditorModule)
            // },
            // {
            //   path: 'drag-and-drop',
            //   loadChildren: () => import('./pages/drag-and-drop/drag-and-drop.module').then(m => m.DragAndDropModule)
            // }
        ]
    },
    {
        path: 'contents',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: ɵ25
            },
        ]
    },
    {
        path: '**',
        redirectTo: '/'
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25 };
